import React, { useState } from "react";
import { Route, Link } from "react-router-dom";
import Navbar from "../presentational/Navbar";
import { textToLink } from "../functions/textToLink";

const NavbarContainer = () => {
    const [state, setState] = useState({
        expanded: false,
        menuItems: ["за нас", "шприцформи", "пластмасови изделия", "информация за инвеститори"]
    });

    const toggleExpanded = () => {
        setState(prevState => ({ expanded: !prevState.expanded }));
    };

    const { expanded, menuItems } = state;

    return (
        <Navbar expanded={expanded} toggleExpanded={toggleExpanded}>
            {menuItems.map(en => {
                const text = en;
                const to = textToLink(`/${en}`);
                return (
                    <Route
                        key={to}
                        path={to}
                        children={({ match }) => (
                            <Link to={to} className={`navbar-item transitioned${match ? ` is-active` : ``}`}>
                                <span>{text}</span>
                            </Link>
                        )}
                    />
                );
            })}
        </Navbar>
    );
}

export default NavbarContainer;



// WEBPACK FOOTER //
// ./src/containers/Navbar.js